module.exports = {"consumptionLabel":"Tipos Consumo","indicatorLabel":{"fuel":"Abastecimento","park":"Estacionamento","toll":"Pedágio"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ConsumptionChart/data.json
// module id = 1873
// module chunks = 0